module.exports = __webpack_public_path__ + "img/completed_delivery.6b2b0a17.svg";